import React, { useState } from "react";
import "./Standard_Delivery_card.css";
import { Link } from "react-router-dom";
import YellowFilledRoundBtn from "../Common_Btn/YellowFilledRoundBtn/YellowFilledRoundBtn";
import OrangeFilledRoundBtn from "../Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import ViewMeassageOffCanvas from "../Common_Modal/ViewMeassageOffCanvas/ViewMeassageOffCanvas";

function Standard_Delivery_card({ order }) {
  const [showOffCanvas, setShowOffCanvas] = useState(false);

  const handleShow = () => setShowOffCanvas(true);
  const handleClose = () => setShowOffCanvas(false);
  return (
    <>
      <section className="Standard_Delivery_card">
        <div className="My_order_card">
          <div className="row">
            {/* Standard_Delivery Details Section */}
            <div className="col-md-12 col-sm-12 ">
              <div className="card_inner_content">
                {/* Order Table */}
                <div className="main_table_holder">
                  <div className="row">
                    <div className="col-lg-9">
                      <div className="subtitle_holder">
                        <h3>{order?.job_id} - Standard Delivery</h3>
                      </div>
                      <div className="inner_title_holder">
                        {order?.Order_Information?.printing_count !== null && (
                          <p>
                            {order?.Order_Information?.printing_count} Document
                            Printing
                          </p>
                        )}

                        <h4>Transaction: {order?.invoice_no}</h4>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="col-lg-3 d-lg-block d-flex justify-content-center mt-lg-0 mt-3">
                      <div className="btn_holder mb-2" onClick={handleShow}>
                        <YellowFilledRoundBtn btnText={"View Messages"} />
                      </div>
                      <Link to={`/re-order/${order.Product?.id}`}>
                        <div className="btn_holder">
                          <OrangeFilledRoundBtn btnText={"Re Order"} />
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OffCanvas Component */}
      <ViewMeassageOffCanvas
        order={order}
        show={showOffCanvas}
        onHide={handleClose}
      />
    </>
  );
}

export default Standard_Delivery_card;
